import { TContentDomain } from '@/types/Content.types';

// Local editor model. `imageUrl` is the persisted image (edit mode); `imageFile`
// is a newly-picked file pending upload after save. `text` holds markdown.
export type TArticleSubsectionDraft = {
  _id: string;
  title: string;
  text: string;
  imageUrl?: string | null;
  imageFile?: File | null;
};

export type TArticleSectionDraft = {
  _id: string;
  title: string;
  text: string;
  imageUrl?: string | null;
  imageFile?: File | null;
  subsections: TArticleSubsectionDraft[];
};

export type TVideoSource = 'mux' | 'youtube';

export type TBrandedFormValues = {
  title: string;
  description: string;
  domains: TContentDomain[];
  subdomains: string[];
  // post (markdown)
  body: string;
  // article
  sections: TArticleSectionDraft[];
  // video
  videoSource: TVideoSource;
  videoFile?: File | null;
  // Existing Mux state (edit mode) — drives publish gating + preview playback.
  muxStatus?: string | null;
  muxPlaybackId?: string | null;
  youtubeUrl: string;
  fullDescription: string;
};

export type TBrandedFormSubmit = {
  values: TBrandedFormValues;
  thumbnailFile: File | null;
};

export type TBrandedFormErrors = Partial<Record<string, string>>;

export type TBrandedFormMode = 'draft' | 'publish';

// A terminal wizard action (publish / save-draft / save-changes).
export type WizardFinalAction = {
  key: string;
  label: string;
  mode: TBrandedFormMode;
  backgroundColor?: string;
  isTransparent?: boolean;
};

// One pending image upload, resolved after the content row is saved.
export type TPendingImageUpload = {
  sectionId: string;
  subsectionId?: string;
  file: File;
};

export const makeEmptySubsection = (): TArticleSubsectionDraft => ({
  _id: crypto.randomUUID(),
  title: '',
  text: '',
  imageUrl: null,
  imageFile: null,
});

export const makeEmptySection = (): TArticleSectionDraft => ({
  _id: crypto.randomUUID(),
  title: '',
  text: '',
  imageUrl: null,
  imageFile: null,
  subsections: [],
});
